import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
const SvgIcon = ({ iconUrl, className }) => {
    const [svgContent, setSvgContent] = useState(null);
    if (!iconUrl) {
        return null;
    }
    useEffect(() => {
        const fetchSvg = async () => {
            try {
                const response = await fetch(iconUrl);
                const data = await response.text();
                setSvgContent(data);
            }
            catch (error) {
                console.error(error);
            }
        };
        fetchSvg();
    }, [iconUrl]);
    if (!svgContent) {
        return null;
    }
    return _jsx("div", { className: className, dangerouslySetInnerHTML: { __html: svgContent } });
};
export default SvgIcon;
